import { render } from "./index.vue?vue&type=template&id=51ac042e&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modules/Authentication/ResetPassword/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51ac042e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51ac042e', __exports__)) {
    api.reload('51ac042e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=51ac042e&ts=true", () => {
    api.rerender('51ac042e', render)
  })

}


export default __exports__